module.exports = __webpack_public_path__ + "img/cygn5.b656dc2b.png";